var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9013_74197)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83167 0C9.18734 0 8.66501 0.522334 8.66501 1.16667V4.16667C8.66501 4.811 9.18734 5.33334 9.83167 5.33334H14.8317C15.476 5.33334 15.9983 4.811 15.9983 4.16667V1.16667C15.9983 0.522334 15.476 0 14.8317 0H9.83167ZM9.83167 6.66683C9.18734 6.66683 8.66501 7.18916 8.66501 7.8335V14.8336C8.66501 15.478 9.18734 16.0003 9.83167 16.0003H14.8317C15.476 16.0003 15.9983 15.478 15.9983 14.8336V7.8335C15.9983 7.18916 15.476 6.66683 14.8317 6.66683H9.83167ZM0.000976562 1.16683C0.000976562 0.522497 0.523311 0.000162761 1.16764 0.000162761H6.16764C6.81201 0.000162761 7.33434 0.522497 7.33434 1.16683V8.16696C7.33434 8.8113 6.81201 9.33363 6.16764 9.33363H1.16764C0.523311 9.33363 0.000976562 8.8113 0.000976562 8.16696V1.16683ZM1.16764 10.6667C0.523311 10.6667 0.000976562 11.189 0.000976562 11.8334V14.8334C0.000976562 15.4777 0.523311 16 1.16764 16H6.16764C6.81201 16 7.33434 15.4777 7.33434 14.8334V11.8334C7.33434 11.189 6.81201 10.6667 6.16764 10.6667H1.16764Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9013_74197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f4b4c445.svg";
export { ForwardRef as ReactComponent };